export const reportsV2En = {
  export: {
    total: 'Total',
  },
  'export-header': {
    dateRange: 'Date Range',
    exportedAt: 'Exported On',
    location: 'Location',
    locations: 'Locations',
    reportName: 'Report Name',
    reportUnit: 'Report Epoch',
    units: {
      days: 'Days',
      hours: 'Hours',
      months: 'Months',
      weeks: 'Weeks',
    },
  },
  feesReport: 'Fees',
  tipsFeesReport: 'Tips & Fees',
  tipsReport: 'Tips',
}
